import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedService } from '../common/shared.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthGuard implements CanActivate {
  public shared: SharedService;

  constructor(private router: Router) {
    this.shared = SharedService.getInstance();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.shared.isLoggedIn()) {
      if (this.shared.adm) {
        this.router.navigate(['/entidade']);
        return false;
      }
      if (!this.shared.unidade) {
        this.router.navigate(['/modulo']);
        return false;
      }
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
